import { useSanctum } from "react-sanctum";

export const usePermissions = () => {

 const { user } = useSanctum();

    const isSuperadmin = user.roles.find((a) => a.name === "superadmin");

    const hasBillingAccess = user.roles.some((role) =>
    ["superadmin", "admin", "secretary"].includes(role.name)
  );

  return { hasBillingAccess, isSuperadmin };

}